import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-4 md:py-5 px-4 text-center" data-id="element-231">
      <div className="max-w-4xl mx-auto" data-id="element-232">
        <span className="inline-block bg-blue-100 text-blue-800 text-sm font-bold px-3 py-1 rounded-full mb-1 uppercase tracking-wide" data-id="element-233">
          La Solución
        </span>

        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-1" data-id="element-234">
          KIT COMPLETO PSICOLOGÍA LISTA
        </h2>

        <p className="text-xl text-gray-600 mb-3 max-w-2xl mx-auto" data-id="element-235">
          Sistema integral de clases, actividades, proyectos y evaluaciones
          diseñadas para secundaria.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4" data-id="element-236">
          {['Listo', 'Probado', 'Organizado', 'Aplicable'].map(item => <div key={item} className="flex items-center gap-2 bg-green-50 px-3 py-1.5 rounded-lg border border-green-100" data-id="element-237">
              <div className="bg-green-500 rounded-full p-1" data-id="element-238">
                <Check className="w-3 h-3 text-white" strokeWidth={4} data-id="element-239" />
              </div>
              <span className="font-bold text-gray-800" data-id="element-240">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}